module.exports = new __parcel__URL__("autobahn.f10725be.jpg").toString();